var _defs, _use;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconLegend0406(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 24,
    viewBox: "0 0 48 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "hl4im3waea",
    d: "M5 8.5h38v7H5z"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "dknfalnxvb",
    maskContentUnits: "userSpaceOnUse",
    maskUnits: "objectBoundingBox",
    x: 0,
    y: 0,
    width: 38,
    height: 7,
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#hl4im3waea"
  })))), _use || (_use = /*#__PURE__*/React.createElement("use", {
    mask: "url(#dknfalnxvb)",
    xlinkHref: "#hl4im3waea",
    fill: "#C5CB83",
    stroke: "#D671AF",
    strokeWidth: 2,
    fillRule: "evenodd",
    strokeDasharray: "4,2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLegend0406);
export default __webpack_public_path__ + "static/media/icon-legend-04-06.24e57660a23acf64103062a7b98d42c1.svg";
export { ForwardRef as ReactComponent };